"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.attachRef = void 0;
/**
 * Attaches game object ref.
 *
 * @param gameObject - Phaser game object.
 * @param ref - Ref callback.
 */
function attachRef(gameObject, ref) {
    if (typeof ref === 'function') {
        ref(gameObject);
    }
    else if (ref && typeof ref === 'object') {
        ref.current = gameObject;
    }
}
exports.attachRef = attachRef;
//# sourceMappingURL=ref.js.map